// Matches the `@font-face "Inter"` declared in styles/base.scss — import this wherever
// a component needs to set fontFamily via MUI's sx prop (Typography defaults to "inherit").
export const FONT_INTER = '"Inter", sans-serif';

// Matches the `@font-face "Globotipo Text"` declared in styles/base.scss (the app's default body font).
export const FONT_GLOBO = '"Globotipo Text", sans-serif';
